import {ActivityIndicator, Dimensions, TouchableOpacity, View} from 'react-native'
import React, {useEffect, useRef, useState} from 'react'
import {ThemedText} from "@app/theme";
import Webcam from "react-webcam";
import CameraIcon from "../../../../../assets/Icons/CameraIcon";

interface CameraPickerWebProps {
    setUserPhoto: Function;
    onCancel: () => void;
    setCapturePhotoOnDeviation: (capturePhoto: boolean) => void;
    setCTALoader: (ctaLoader: boolean) => void;
    previousPhoto?: string;
    setOpenCamera: (openCamera: boolean) => void;
    navigation: any;
    setRetriggerCamera: (reTriggerCamera: boolean) => void;

}

const CameraPickerWeb: React.FC<CameraPickerWebProps> = ({
                                                             setUserPhoto,
                                                             onCancel,
                                                             setCapturePhotoOnDeviation,
                                                             setCTALoader,
                                                             previousPhoto,
                                                             setOpenCamera,
                                                             navigation,
                                                             setRetriggerCamera
                                                         }) => {
    const cameraRef = useRef(null);
    const setCameraWebRef = async (ref: any) => {
        cameraRef.current = ref;
    };
    const [cameraLoaded, setCameraLoaded] = useState(false)

    useEffect(() => {
        setCTALoader(false)
    }, []);

    const loaderView = () => {
        return (
            <View style={{
                position: "absolute",
                right: 0,
                left: 0,
                bottom: 0,
                top: 0,
                justifyContent: "center",
                alignSelf: "center"
            }}>
                <ActivityIndicator size="small" color="white"/>
            </View>
        )
    }
    const handleUserMediaError = (error) => {
        console.error("Webcam error:", error);

        if (
            error.name === "NotAllowedError" ||
            error.name === "PermissionDeniedError"
        ) {
            // User denied camera permission
            alert("Camera permission was denied.");
        }
    };

    return (
        <View style={{flex: 1, backgroundColor: "black"}}>
            <View style={{
                height: '75%',
                width: '100%',
                position: 'absolute',
                top: '5%',
                left: 0,
                right: 0,
                overflow: 'hidden'
            }}>
                <Webcam
                    onUserMedia={() => {
                        setCameraLoaded(true)
                    }}
                    ref={setCameraWebRef}
                    audio={false}
                    screenshotFormat='image/jpeg'
                    mirrored={true}
                    onUserMediaError={handleUserMediaError}
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: "cover", // Changed from "contain" to "cover" for better filling
                    }}
                />
            </View>
            {!cameraLoaded && loaderView()}
            <TouchableOpacity
                style={{
                    position: 'absolute',
                    bottom: 50,
                    left: 32,
                }}
                onPress={() => {
                    if (previousPhoto) {
                        setUserPhoto(previousPhoto)
                    }
                    onCancel()
                    setRetriggerCamera(false)
                    navigation.setParams({capturePhotoOnDeviation: false});
                }}
            >
                <ThemedText variant={"b1s"} color={"white"}>
                    Cancel
                </ThemedText>

            </TouchableOpacity>
            <TouchableOpacity
                style={{
                    height: 70,
                    width: 70,
                    position: 'absolute',
                    bottom: 30,
                    left: '50%',
                    transform: [{translateX: -35}],
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
                onPress={async () => {
                    const base64Image =
                        //@ts-ignore
                        await cameraRef.current.getScreenshot();
                    setUserPhoto(base64Image)
                    setOpenCamera(false)
                    setRetriggerCamera(false)
                    navigation.setParams({capturePhotoOnDeviation: false});
                }}
            >
                <CameraIcon/>

            </TouchableOpacity>
        </View>
    )
}

export default CameraPickerWeb